export class UserAccountDTO {
  accountIndividualId!: string;
  individualId!: string;
  token!: string;
  status!: string;
  isCertified!: boolean;
  name!: string;
  surname!: string;
  addProfile!: string;
  taxId!: string;
  euraCompany!: string;
  canStillUseMyClinic!: boolean;
  isExpired!: boolean;
  canDownloadMedicalData!: boolean;
  botAllowed!: boolean;
  multilanguageAllowed!: boolean;
  travelServiceAllowed!: boolean;
  consultServiceAllowed!: boolean;
  personalServiceAllowed!: boolean;
  symptomsServiceAllowed!: boolean;
  careManagerServiceAllowed!: boolean;
  email!: string;
  phoneNumber!: string;
  country!: string;
  district!: string;
  city!: string;
  address!: string;
  consents!: string;
  postalCode!: string;
  expirationDate!: string;
  namePolicy!: string;
  policyUrl!: string;
  activationDate!: string;
  birthDate!: string;
  gender!: string;
  functions!: string[];
  tollFreeNumber!: string;
  phoneNumberBlack!: string;
  linkToClaimsPortal!: string;
  mainIndividualId!: string;
  requestAssistanceCovidEnabled!: boolean;
  isAccountDisabledFromMaster!: boolean;
  profileNeedsToBeUpdated!: boolean;
}

export class UserLoginDataDTO {
  username!: string;
  password!: string;
  companyId!: string;
}

export class UsersAccountDTO {
  individualId!: string;
  fullName!: string;
  relatedProfiles!: RelatedProfileDTO[];
  email!: string;
  birthdate!: string;
  isAdult!: boolean;
  phone?: string;
}

export class RelatedProfileDTO {
  individualId!: string;
  fullName!: string;
  phone?: string;
  email?: string;
  roleId!: string;
  roleName!: string;
  connectionId!: string;
  isFemale!: boolean;
  isAdult!: boolean;
  isShared!: boolean;
  relatedMajorUsers!: RelatedMajorUserDTO[];
  isDisableEnabled!: boolean;
  isMinorDelegateEnabled!: boolean;
  isChangeProfileEnabled!: boolean;
  isMajorDelegateEnabled!: boolean;
}

export class RelatedMajorUserDTO {
  individualId!: string;
  fullName!: string;
}

export class UserRegisterDataDTO {
  name!: string;
  surname!: string;
  taxId!: string;
  address!: string;
  relatedProfiles?: any[];
  functions?: string[];
  postalCode!: string;
  userName!: string;
  email!: string;
  phone!: string;
  isPhoneCertified?: boolean;
  birthDate!: string;
  fbUserId!: string;
  googleUserId!: string;
  privacy_eai_iccs!: boolean;
  privacy_eai_profile!: boolean;
  privacy_vai_iccs!: boolean;
  privacy_vai_profile!: boolean;
  companyId!: string;
  registerWithFacebook!: boolean;
  registerWithGoogle!: boolean;
  birthCity?: { code: string; description: string };
  city?: {code: string; description: string};
  birthCountry?: { code: string; description: string };
  birthDistrict?: { code: string; description: string };
  tollFreeNumber?: string;
  phoneNumberBlack?: string;
  country?: { code: string; description: string };
  district?: { code: string; description: string };
  mobilePhone?: string;
  individualId?: string;
  updateFromSSO?: boolean;
  gender?: string;
}

export class AccountDataDTO extends UsersAccountDTO {
  connections?: Array<{ connectionId: string; contact1Id: string; contact1Name: string; contact2Id: string; contact2Name: string; roleId: string; roleName: string }>;
  customer?: UserRegisterDataDTO;
  functions?: Array<string>;
  product?: ProductDataDTO;
  linkToClaimsPortal?: string;
  requestAssistanceCovidEnabled?: boolean;
}

export class ProductDataDTO {
  id?: string;
  name?: string;
  policyNumber?: string;
  euraCompany?: string;
  activationDate?: string;
  expirationDate?: string;
  canStillUseMyClinic?: boolean;
  tollFreeNumber?: string;
  phoneNumber?: string;
}

export class TravelCountry {
  code!: string;
  description!: string;
}

export class CallMeBackTravel {
  doc: any;
  innerErrorPayload: any;
  eaAccount: any;
  shortLinksResponse: any;
  profiliAssociati: any;
  taxIdDecode: any;
  canSendRequestResponse?: boolean;
  consultRequestResponse: any;
  counters: any;
  countries: any;
  travelCountries: any;
  cities: any;
  districts: any;
  birthCountries: any;
  kinship: any;
  profileConnections: any;
  companyIdsList: any;
  taxId: any;
  paymentGatewayUrlChunk: any;
  isCodeValid?: boolean;
  isPolicyHolder?: boolean;
  individualId: any;
  isFirstTimeUsed?: boolean;
  eaResponseConference: any;
  eaResponseTwilioConference: any;
  eaConferenceRoomInformations: any;
  isActivateUser?: boolean;
  companyId: any;
  uploadDocumentResponse?: boolean;
  sendOtpResult: any;
  validateOtpResponse: any;
  specialistFasdacDto: any;
  result?: boolean;
  errorMessage?: string;
  errorCode: any;
  errorMessageTranslation?: string;
  innerErrorMessage?: string;
}